import { mapActions } from 'vuex';
import { formMixin, validators } from '@/components/forms/mixin';

export default {
  mixins: [
    formMixin,
  ],
  validations: {
    fields: {
      newPassword: validators.password,
      newPasswordConfirmation: validators.passwordConfirmation('newPassword'),
    },
  },
  data() {
    return {
      fields: {
        newPassword: '',
        newPasswordConfirmation: '',
      },
    };
  },
  methods: {
    ...mapActions('notifications', ['setSuccessSideNotificationWithTimeoutCallback']),
    ...mapActions('user', ['setPassword']),
    onSubmit() {
      if (this.formIsValid() && this.formDisable()) {
        const payload = {
          newPassword: this.fields.newPassword,
        };
        this.setPassword(payload)
          .then(this.formEnable)
          .then(() => {
            this.setSuccessSideNotificationWithTimeoutCallback({
              text: 'Password Set.',
              callback: () => this.$router.go(-1),
            });
          })
          .catch(this.formHandleErrors);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-set-password/account-set-password.js